import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 py-12 px-4 border-t border-slate-900" data-id="element-94">
      <div className="max-w-4xl mx-auto text-center" data-id="element-95">
        <h2 className="text-2xl font-black text-white mb-2" data-id="element-96">
          💛 NUEVO NIVEL™
        </h2>
        <p className="text-slate-400 mb-6" data-id="element-97">
          El sistema de recursos N°1 para padres de niños con TDAH en habla
          hispana.
        </p>
        <p className="text-amber-400 font-bold mb-12" data-id="element-98">
          Porque acompañar a tu hijo no debería costarte todas las noches del
          año.
        </p>

        <div className="bg-slate-900 rounded-2xl p-6 border border-slate-800 mb-12 text-left overflow-x-auto" data-id="element-99">
          <h3 className="text-white font-bold mb-4 text-center" data-id="element-100">
            📋 RESUMEN FINAL
          </h3>
          <table className="w-full text-sm min-w-[400px]" data-id="element-101">
            <tbody className="divide-y divide-slate-800" data-id="element-102">
              <tr data-id="element-103">
                <td className="py-2 text-slate-400" data-id="element-104">🏷️ Marca</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-105">
                  Nuevo Nivel™
                </td>
              </tr>
              <tr data-id="element-106">
                <td className="py-2 text-slate-400" data-id="element-107">🌐 Web</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-108">
                  www.nuevonivel.shop
                </td>
              </tr>
              <tr data-id="element-109">
                <td className="py-2 text-slate-400" data-id="element-110">📧 Soporte</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-111">
                  soportenuevonivel@gmail.com
                </td>
              </tr>
              <tr data-id="element-112">
                <td className="py-2 text-slate-400" data-id="element-113">📘 Combo Completo</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-114">
                  $46.000 → $19.990 ARS
                </td>
              </tr>
              <tr data-id="element-115">
                <td className="py-2 text-slate-400" data-id="element-116">🏆 Combo + Protocolo</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-117">
                  $58.000 → $27.990 ARS
                </td>
              </tr>
              <tr data-id="element-118">
                <td className="py-2 text-slate-400" data-id="element-119">🛡️ Garantía</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-120">
                  7 días sin preguntas
                </td>
              </tr>
              <tr data-id="element-121">
                <td className="py-2 text-slate-400" data-id="element-122">⚡ Acceso</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-123">
                  5 minutos — PDF inmediato
                </td>
              </tr>
              <tr data-id="element-124">
                <td className="py-2 text-slate-400" data-id="element-125">💳 Pago</td>
                <td className="py-2 text-white font-medium text-right" data-id="element-126">
                  Mercado Pago · Tarjeta · Transferencia
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-slate-500 text-xs space-y-2" data-id="element-127">
          <p data-id="element-128">📧 soportenuevonivel@gmail.com | 🌐 www.nuevonivel.shop</p>
          <p data-id="element-129">
            © Nuevo Nivel™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="mt-4 text-slate-600 italic" data-id="element-130">
            💛 "La próxima semana puede ser la mejor que vivieron como familia."
          </p>
        </div>
      </div>
    </footer>;
}